import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from 'lightgallery/plugins/zoom';
import { getGlobalSmoother } from './smoothScroll.js';

// Extrae el valor Y de un matrix3d CSS transform
function getScrollYFromTransform(transform) {
    if (!transform) return null;
    const match = transform.match(/matrix3d\([\d\s.,\-]+,\s*([\d.\-]+),\s*0,\s*1\)/);
    return match ? Math.abs(parseFloat(match[1])) : null;
}

// Dispositivos táctiles (móvil/tablet) = scroll nativo, sin transform de ScrollSmoother
function isNativeScrollDevice() {
    return window.matchMedia('(pointer: coarse)').matches;
}

function lightgalleryImages () {

    const galleries = document.querySelectorAll('.lightgallery__images');

    galleries.forEach(gallery => {

        const lg = gallery;
        let savedTransform = '';
        let savedScrollTop = 0;
        let useNativeScroll = false;
        let observer = null;

        lg.addEventListener('lgBeforeOpen', () => {
            const smoother = getGlobalSmoother();
            const smoothContent = document.getElementById('smooth-content');

            savedScrollTop = smoother ? smoother.scrollTop() : window.scrollY;
            savedTransform = smoothContent ? smoothContent.style.transform : '';

            // Ya no depende de savedScrollTop > 0, así funciona también en scrollY = 0
            useNativeScroll = isNativeScrollDevice();

            if (!useNativeScroll && smoothContent) {
                // DESKTOP: congelar el transform
                observer = new MutationObserver(() => {
                    if (smoothContent.style.transform !== savedTransform) {
                        smoothContent.style.transform = savedTransform;
                    }
                });
                observer.observe(smoothContent, { attributes: true, attributeFilter: ['style'] });

            } else if (useNativeScroll) {
                // MÓVIL / TABLET: lock real con position:fixed
                if (smoother) smoother.paused(true);
                document.documentElement.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.top = `-${savedScrollTop}px`;
                document.body.style.left = '0';
                document.body.style.width = '100%';
            }
        });

        lg.addEventListener('lgBeforeClose', () => {
            if (useNativeScroll) return; // el restore de móvil/tablet se hace en lgAfterClose

            // DESKTOP: restaurar a partir del transform congelado
            const scrollY = getScrollYFromTransform(savedTransform);
            const smoother = getGlobalSmoother();
            if (smoother && scrollY !== null) smoother.scrollTop(scrollY);
        });

        lg.addEventListener('lgAfterClose', () => {
            if (useNativeScroll) {
                // MÓVIL / TABLET: liberar el body y restaurar posición
                const smoother = getGlobalSmoother();
                document.documentElement.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.width = '';

                if (smoother) {
                    smoother.paused(false);
                    smoother.scrollTop(savedScrollTop);
                } else {
                    window.scrollTo(0, savedScrollTop);
                }
            }

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (observer) {
                        observer.disconnect();
                        observer = null;
                    }
                });
            });
        });

        lightGallery(lg, {
            plugins: [lgVideo, lgZoom],
            selector: 'a',
            counter: false,
            download: false,
            zoomFromOrigin: false,
            container: document.body,
            hideScrollbar: false,
            mobileSettings: {
                controls: true,
            },
            vimeoPlayerParams: {
                autoplay: 1,
                byline: 0,
                portrait: 0,
                color: 'A90707'
            }
        });

    });

}

export default lightgalleryImages;